import AppGradientText, {
  type IGradientTextProps,
} from "@core-components/text/GradientText";

const SSLoLGradientText: React.FC<IGradientTextProps> = ({
  children,
  className,
  ...rest
}) => {
  return (
    <AppGradientText
      className={`text-gradient-blue-purple ${className}`}
      {...rest}
    >
      {children}
    </AppGradientText>
  );
};

export default SSLoLGradientText;
